import loader from '../moduleLoader.js';
import * as basicLightbox from 'basiclightbox';
import Flickity from 'flickity';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { disableFocusBehindModal, enableFocusBehindModal } from '../../helpers/modalHelper';

class Lightbox {
    constructor(trigger) {
        this.trigger = trigger;
        this.activeElement = undefined;
        this.open = this.open.bind(this);
        this.handleEscKey = this.handleEscKey.bind(this);
        this.handleAfterClose = this.handleAfterClose.bind(this);
        this.handleAfterOpen = this.handleAfterOpen.bind(this);
        this.instance = undefined;
        this.groupedBy = undefined;
        this.items = [];
        this.visions = [];
        this.el = undefined;
        this.nextButton = (new DOMParser().parseFromString('<button class="lightbox__next">Next</button>', 'text/html')).body.firstChild;
        this.prevButton = (new DOMParser().parseFromString('<button class="lightbox__prev">Prev</button>', 'text/html')).body.firstChild;;
    }
    init() {
        this.trigger.addEventListener('click', this.open);
        document.addEventListener('keydown', this.handleEscKey);

        if (this.trigger.classList.contains('fullscreen-button--hidden')) {
            window.addEventListener('scroll', function () {
                if (this.trigger.getBoundingClientRect().top < window.innerHeight / 1.5) {
                    this.trigger.classList.remove('fullscreen-button--hidden');
                }
            }.bind(this));
        }
    }

    open(e) {
        e.preventDefault();
        this.activeElement = this.trigger;
        this.groupedBy = document.getElementById(this.trigger.dataset.groupby);
        let html;
        if (this.groupedBy) {
            html = this.getSliderHtml()
        }
        else {
            html = this.trigger.dataset.embed;
        }

        this.instance = basicLightbox.create(
            html, {
            closable: true,
            afterShow: this.handleAfterOpen,
            afterClose: this.handleAfterClose,
            afterPlaceholder: '<button class="basiclightbox__close">x</button>',
        });

        this.instance.show();


    }

    handleAfterOpen(instance) {
        this.el = instance.element();
        this.initSliderAfterShow(instance);
        const closeButton = instance.element().querySelector('.basiclightbox__close')
        closeButton.addEventListener('click', (e) => {
            this.instance.close();
        });
        closeButton.focus();
        disableBodyScroll(instance.element());
        disableFocusBehindModal(instance.element());
    }

    handleAfterClose(instance) {
        this.nextButton.removeEventListener('click', this.handleNextButton);
        document.removeEventListener('keydown', this.handleKeyPress);
        enableBodyScroll(instance.element());
        enableFocusBehindModal();
        this.trigger.focus();
    }

    initSliderAfterShow(instance) {
        const lightbox = document.querySelector('.lightbox__slider');
        if (lightbox == null) return;

        const items = lightbox.querySelectorAll('.lightbox');
        if (items.length <= 1) return;

        for (var i = 0; i < items.length; i++) {
            const el = items[i].querySelector('.lightbox__index');
            if (el) el.innerHTML = i + 1;
        }

        lightbox.style.height = `${window.innerHeight}px`;
        document.addEventListener('scroll', () => {
            lightbox.style.height = `${window.innerHeight}px`;
        });
        const currentIndex = this.items.indexOf(this.activeElement);

        var flkty = new Flickity('.lightbox__slider', {
            cellAlign: 'left',
            contain: true,
            wrapAround: false,
            pageDots: false,
            lazyLoad: 2
        });
        flkty.select(currentIndex, false, true);

        if (currentIndex >= flkty.slides.length - 2) {
            window.dispatchEvent(new CustomEvent('FlktyLastSlide', { 'detail': flkty }));
        }

        flkty.on('change', function (index) {
            if (index === this.slides.length - 2) {
                window.dispatchEvent(new CustomEvent('FlktyLastSlide', { 'detail': flkty }));
            }
        });
    }

    handleEscKey(e) {
        if (typeof this.instance !== 'undefined' && e.key === 'Escape') {
            this.instance.close();
        }
    }

    getSliderHtml() {
        var html = "";
        this.items = Array.from(this.groupedBy.querySelectorAll('[data-module=Lightbox]'));
        html = '<div class="lightbox__slider">';
        this.items.forEach((item) => {
            html += item.dataset.embed;
        });
        html += '</div>';
        return html;
    }
}

loader.add('Lightbox', Lightbox);

export default Lightbox;
